module.exports = __webpack_public_path__ + "img/35_7.a5a1fe0b.png";